// src/utils/load-script.ts
import _loadScript from "load-script";
function loadScript(src) {
  return new Promise((resolve, reject) => {
    _loadScript(src, (err, script) => {
      if (err)
        reject(err);
      else
        resolve(script);
    });
  });
}

export {
  loadScript
};
//# sourceMappingURL=chunk-F6WKUPXL.mjs.map